import ReactStars from "react-rating-stars-component";
import "./feedback.component.scss";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {  submitFeedback } from "../../state/slice";
import useApi from "../../hooks/useApi";
import { useEffect, useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { ChevronDown } from "react-bootstrap-icons";
const Feedback = () => {
  const dispatch = useDispatch();
  const logoQuestion = require("../../assets/question-circle.svg")?.default;
  const feedbackLogo = require("../../assets/Feedback.svg")?.default;

  const storedFeedback = useSelector((state: any) => state.feedback);
  const chatHistoryId = useSelector((state: any) => state.chatHistoryId);
  const interactionId = useSelector((state: any) => state.interactionId);

  const { post } = useApi();
  // const showRecommendedQuestions = useSelector(
  //   (state: any) => state.showRecommendedQuestions
  // );



  const placeHolderTextAnswerQuality =
    "Please share your thoughts on the Accuracy, Relevance and Quality of Tim’s Response.";
  const placeHolderTextUserInterface =
    "Please share your thoughts on the Design, Navigation, Layout and Accessibility of Ask Tim.";
  const placeHolderTextUserExperience =
    "Please share your thoughts on the Usability, Performance/Speed and Functionality of Ask Tim.";

  const { handleSubmit, control, setValue, reset,watch } = useForm({
    defaultValues: {
      feedback: {
        answerQuality: { rating: 0, answer: "" },
        userInterface: { rating: 0, answer: "" },
        userExperience: { rating: 0, answer: "" },
      },
    },
  });

  const fetchFeedbackObject = (input) => {
    const caseValue = input?.feedbacktype?.toString()?.toLowerCase();
    console.log("setting value", input, input?.feedback_score);
    switch (caseValue) {
      case "answer_quality":
        setValue("feedback.answerQuality.answer", input?.comment);
        setValue("feedback.answerQuality.rating", input?.feedback_score, {
          shouldValidate: true,
          shouldDirty: true,
        });
        setRating1(Number(input?.feedback_score));
        forceUpdate();
        break;
      case "user_interface":
        setValue("feedback.userInterface.answer", input?.comment);
        setValue("feedback.userInterface.rating", input?.feedback_score, {
          shouldValidate: true,
          shouldDirty: true,
        });
        setRating2(Number(input?.feedback_score));
        forceUpdate();
        break;
      case "user_experience":
        setValue("feedback.userExperience.answer", input?.comment);
        setValue("feedback.userExperience.rating", input?.feedback_score, {
          shouldValidate: true,
          shouldDirty: true,
        });
        setRating3(Number(input?.feedback_score));
        forceUpdate();
        break;

      default:
        setValue("feedback.answerQuality.answer", input?.comment);
        setValue("feedback.answerQuality.rating", input?.feedback_score, {
          shouldValidate: true,
          shouldDirty: true,
        });
        setRating1(Number(input?.feedback_score));
        forceUpdate();
        break;
    }
  };
  useEffect(() => {
    resetPage();
    if (storedFeedback && storedFeedback?.length > 0) {
      storedFeedback?.forEach((element) => {
        fetchFeedbackObject(element);
      });
    } else {
     
    }
  }, [storedFeedback, setValue]);

  // useEffect(() => {
  //  console.log("showRecommendedQuestions", showRecommendedQuestions);
  //   resetPage();
    
  // }, [showRecommendedQuestions]);
  const resetPage = () => {
    console.log("reset storedfeedback feedback form");
    reset();
    setRating1(0);
    setRating2(0);
    setRating3(0);
    forceUpdate();
  };

  const onFeedbackSubmit = async (data) => {
    try {
      console.log("Submitted Feedback:", data);

      const payload = {
        interaction_id: interactionId,
        feedbacks: [
          {
            feedbacktype: "ANSWER_QUALITY",
            comment: data.feedback.answerQuality.answer,
            feedback_score: data.feedback.answerQuality.rating,
          },
          {
            feedbacktype: "USER_INTERFACE",
            comment: data.feedback.userInterface.answer,
            feedback_score: data.feedback.userInterface.rating,
          },
          {
            feedbacktype: "USER_EXPERIENCE",
            comment: data.feedback.userExperience.answer,
            feedback_score: data.feedback.userExperience.rating,
          },
        ],
      };
      const response: any = await post("feedbacks/", payload);
      console.log(response);

      if (response?.status === 201) {
        const datasubmit = { ...data.feedback, submitted: true };
        dispatch(submitFeedback(datasubmit));
        setOpen(false);
      } else {
        console.error("something went wrong in submitting feedback");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // const renderFormSubmittedView = () => {
  //   return (
  //     <div className="feedbackSubmittedContainer">
  //       Thank you for your feedback. Your responses are valuable in improving
  //       Ask Tim
  //     </div>
  //   );
  // };
  const [rating1, setRating1] = useState(0);
  const [rating2, setRating2] = useState(0);
  const [rating3, setRating3] = useState(0);
  const [updateKey, setUpdateKey] = useState(0);

  const forceUpdate = () => {
    setUpdateKey((prevKey) => prevKey + 1);
  };
  const getValue = (field, rating) => {
    // console.log("getvalue", field, rating, chatHistoryId);
    return chatHistoryId > -1 ? rating : field.value;
  };

  const [open, setOpen] = useState(false);
  const widgetRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        widgetRef.current &&
        !widgetRef.current?.contains(e.target) &&
        !buttonRef.current?.contains(e.target)
      ) {
        // setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const textareaQuality = document.querySelector('[name="feedback.answerQuality.answer"]') as HTMLTextAreaElement;
  const textareaInterface = document.querySelector('[name="feedback.userInterface.answer"]') as HTMLTextAreaElement;
  const textareaExperience = document.querySelector('[name="feedback.userExperience.answer"]') as HTMLTextAreaElement;


  const handleResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // reset the height first
      textarea.style.maxHeight = "160px"; // reset the height first
      textarea.style.height = `${textarea.scrollHeight}px`; // set height based on content
    }
  }
  useEffect(() => {
   handleResize(textareaQuality);
  }, [watch("feedback.answerQuality.answer")]);
  useEffect(() => {
    handleResize(textareaInterface);
   }, [watch("feedback.userInterface.answer")]);
   useEffect(() => {
    handleResize(textareaExperience);
   }, [watch("feedback.userExperience.answer")]);

    const StarFilled = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="gold" width="20" height="20">
      <path d="M12 2l2.9 8.3H24l-7.3 5.3 2.8 8.4L12 17.3l-7.5 5.2 2.8-8.4L0 10.3h9.1z" />
    </svg>
  );

  const StarEmpty1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" stroke="grey" strokeWidth="1" width="20" height="20">
      <path d="M12 2l2.9 8.3H24l-7.3 5.3 2.8 8.4L12 17.3l-7.5 5.2 2.8-8.4L0 10.3h9.1z" />
    </svg>
  );
  const renderNewForm = () => {
    return (
      <>
        {open && (
          <div
            ref={widgetRef}
            className="feedbackContainer-new"
            style={{
              position: "fixed",
              bottom: "0", // Adjust based on button height
              // left: "50%",
              // transform: "translateX(-50%)",
              zIndex: 1050,
              width: "25%",
              right: "0",
              maxWidth: "25%",
            }}
          >
            <Card className="shadow position-relative">
              <Card.Body>
                <div
                  className="feedbackContainer"
                  // style={{ visibility: showRecommendedQuestions ? "visible" : "hidden" }}
                >
                  <div className="container">
                    <div className="row position-relative">
                      <div className="col-10 headingfeedback">
                        <img src={logoQuestion} alt="feedback" />
                        Feedback
                      </div>
                      <div
                        className="col-2 d-flex justify-content-end align-self-start headingfeedback2"
                        onClick={() => setOpen(false)}
                        title="Collapse"
                      >
                        <ChevronDown size={20} />
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <form onSubmit={handleSubmit(onFeedbackSubmit)}>
                    <div className="container">
                      <div className="row">
                        {/* <div className="col-12 questiontype">Answer Quality</div> */}
                        <div className="col-12 rating">
                          <span className="ratingstext"> Rate the answer</span>
                          <Controller
                            name="feedback.answerQuality.rating"
                            key={updateKey}
                            control={control}
                            render={({ field }) => (
                              <ReactStars
                                edit={chatHistoryId > -1 ? false : true}
                                count={5}
                                onChange={(newValue) => {
                                  console.log("newchnage", newValue);
                                  field.onChange(newValue);
                                  setRating1(Number(newValue));
                                }}
                                size={24}
                              
                                activeColor="#ffd700"
                                emptyIcon={<StarEmpty1 />}
                                filledIcon={<StarFilled />}
                                name="feedback.answerQuality.rating"
                                value={getValue(field, rating1)}
                              />
                            )}
                          />
                        </div>

                        <div className="col-12 feedbackText">
                          <textarea
                            
                            rows={3}
                            style={{
                            
                              caretColor: "black",
                            }}
                            disabled={chatHistoryId > -1 ? true : false}
                            wrap="soft"
                            {...control.register(
                              "feedback.answerQuality.answer"
                            )}
                           
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row">
                        {/* <div className="col-12 questiontype">User Interface</div> */}
                        <div className="col-12 rating">
                          <span className="ratingstext">
                            {" "}
                            Rate the user interface
                          </span>
                          <Controller
                            name="feedback.userInterface.rating"
                            control={control}
                            key={updateKey}
                            render={({ field }) => (
                              <ReactStars
                                edit={chatHistoryId > -1 ? false : true}
                                count={5}
                                onChange={(newValue) => {
                                  console.log("newchnage", newValue);
                                  field.onChange(newValue);
                                  setRating2(newValue);
                                }}
                                emptyIcon={<StarEmpty1 />}
                                filledIcon={<StarFilled />}
                                size={24}
                                activeColor="#ffd700"
                                value={getValue(field, rating2)}
                              />
                            )}
                          />
                        </div>

                        <div className="col-12 feedbackText">
                          <textarea
                            rows={3}
                            onFocus={(e) => (e.target.placeholder = "")}
                            // onBlurCapture={(e) => {
                            //   if (!e.target.value.trim()) {
                            //     e.target.placeholder = placeHolderTextAnswerQuality;
                            //   }
                            // }}
                            disabled={chatHistoryId > -1 ? true : false}
                            // placeholder={placeHolderTextUserInterface}
                            wrap="soft"
                            {...control.register(
                              "feedback.userInterface.answer"
                            )}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="container">
                      <div className="row">
                        {/* <div className="col-12 questiontype userexp">User Experience</div> */}
                        <div className="col-12 rating">
                          <span className="ratingstext">
                            {" "}
                            Rate the user experience
                          </span>
                          <Controller
                            name="feedback.userExperience.rating"
                            control={control}
                            key={updateKey}
                            render={({ field }) => (
                              <ReactStars
                                edit={chatHistoryId > -1 ? false : true}
                                count={5}
                                onChange={(newValue) => {
                                  console.log("newchnage", newValue);
                                  field.onChange(newValue);
                                  setRating3(newValue);
                                }}
                                size={24}
                                emptyIcon={<StarEmpty1 />}
                                filledIcon={<StarFilled />}
                                activeColor="#ffd700"
                                value={getValue(field, rating3)}
                              />
                            )}
                          />
                        </div>

                        <div className="col-12 feedbackText">
                          <textarea
                            onFocus={(e) => (e.target.placeholder = "")}
                            // onBlurCapture={(e) => {
                            //   if (!e.target.value.trim()) {
                            //     e.target.placeholder = placeHolderTextAnswerQuality;
                            //   }
                            // }}
                            disabled={chatHistoryId > -1 ? true : false}
                            rows={3}
                            // placeholder={placeHolderTextUserExperience}
                            wrap="soft"
                            {...control.register(
                              "feedback.userExperience.answer"
                            )}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="container">
                      <div className="row">
                        <div className="col-12 text-end">
                          <button
                            className={`feedback-submit cancel${
                              chatHistoryId > -1 ? "disable" : ""
                            }`}
                            disabled={chatHistoryId > -1}
                            title="Cancel Feedback"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpen(false);
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            className={`feedback-submit ${
                              chatHistoryId > -1 ? "disable" : ""
                            }`}
                            type="submit"
                            disabled={chatHistoryId > -1}
                            title="Submit Feedback"
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </div>
        )}

        {/* Fixed button */}
        <div
          className="feedback-bottom-con"
          style={{
            position: "fixed",
            bottom: 0,
            // width: "100%",
            right: 0,
            // background: "#fff",
            // borderTop: "1px solid #ddd",
            padding: "10px",
            textAlign: "right",
            zIndex: 1060,
            borderRadius: "24px",
          }}
        >
          {!open && !storedFeedback?.submitted && (
            <Button
              title="Give Feedback"
              className="feedback-btn"
              ref={buttonRef}
              onClick={() => setOpen((prev) => !prev)}
            >
              <img src={feedbackLogo} alt="feedback" />{" "}
              <span className="feedback-text">Give Feedback</span>
            </Button>
          )}

          {storedFeedback?.submitted && (
            <p className="feedback-sent">Your feedback has been sent.</p>
          )}
        </div>
      </>
    );
  };
  const renderForm = () => {
    return (
      <div
        className="feedbackContainer"
        style={{ visibility: storedFeedback?.length ? "visible" : "hidden",maxHeight: storedFeedback?.length ? "100%" : "1%",marginBottom: storedFeedback?.length ? "37%" : "0"  }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 headingfeedback">Feedback</div>
          </div>
        </div>
        <form onSubmit={handleSubmit(onFeedbackSubmit)}>
          <div className="container">
            <div className="row">
              <div className="col-12 questiontype">Answer Quality</div>
              <div className="col-12 rating">
                <span className="ratingstext"> Rate the answer</span>
                <Controller
                  name="feedback.answerQuality.rating"
                  key={updateKey}
                  control={control}
                  render={({ field }) => (
                    <ReactStars
                      edit={chatHistoryId > -1 ? false : true}
                      count={5}
                      onChange={(newValue) => {
                        console.log("newchnage", newValue);
                        field.onChange(newValue);
                        setRating1(Number(newValue));
                      }}
                      size={24}
                      color="black"
                      activeColor="#ffd700"
                      name="feedback.answerQuality.rating"
                      value={getValue(field, rating1)}
                    />
                  )}
                />
              </div>

              <div className="col-12 feedbackText">
                <textarea
                aria-label="Feedback comment"
                  onFocus={(e) => (e.target.placeholder = "")}
                  onBlurCapture={(e) => {
                    if (!e.target.value.trim()) {
                      e.target.placeholder = placeHolderTextAnswerQuality;
                    }
                  }}
                  rows={3}
                  placeholder={placeHolderTextAnswerQuality}
                  disabled={chatHistoryId > -1 ? true : false}
                  wrap="soft"
                  {...control.register("feedback.answerQuality.answer")}
                  style={{ caretColor: "black" }}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12 questiontype">User Interface</div>
              <div className="col-12 rating">
                <span className="ratingstext"> Rate the user interface</span>
                <Controller
                  name="feedback.userInterface.rating"
                  control={control}
                  key={updateKey}
                  render={({ field }) => (
                    <ReactStars
                      edit={chatHistoryId > -1 ? false : true}
                      count={5}
                      onChange={(newValue) => {
                        console.log("newchnage", newValue);
                        field.onChange(newValue);
                        setRating2(newValue);
                      }}
                      size={24}
                      activeColor="#ffd700"
                      value={getValue(field, rating2)}
                    />
                  )}
                />
              </div>

              <div className="col-12 feedbackText">
                <textarea
                aria-label="Feedback comment"
                  rows={3}
                  onFocus={(e) => (e.target.placeholder = "")}
                  onBlurCapture={(e) => {
                    if (!e.target.value.trim()) {
                      e.target.placeholder = placeHolderTextAnswerQuality;
                    }
                  }}
                  disabled={chatHistoryId > -1 ? true : false}
                  placeholder={placeHolderTextUserInterface}
                  wrap="soft"
                  {...control.register("feedback.userInterface.answer")}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-12 questiontype userexp">User Experience</div>
              <div className="col-12 rating">
                <span className="ratingstext"> Rate the user experience</span>
                <Controller
                  name="feedback.userExperience.rating"
                  control={control}
                  key={updateKey}
                  render={({ field }) => (
                    <ReactStars
                      edit={chatHistoryId > -1 ? false : true}
                      count={5}
                      onChange={(newValue) => {
                        console.log("newchnage", newValue);
                        field.onChange(newValue);
                        setRating3(newValue);
                      }}
                      size={24}
                      activeColor="#ffd700"
                      value={getValue(field, rating3)}
                    />
                  )}
                />
              </div>

              <div className="col-12 feedbackText">
                <textarea
                aria-label="Feedback comment"
                  onFocus={(e) => (e.target.placeholder = "")}
                  onBlurCapture={(e) => {
                    if (!e.target.value.trim()) {
                      e.target.placeholder = placeHolderTextAnswerQuality;
                    }
                  }}
                  disabled={chatHistoryId > -1 ? true : false}
                  rows={3}
                  placeholder={placeHolderTextUserExperience}
                  wrap="soft"
                  {...control.register("feedback.userExperience.answer")}
                ></textarea>
              </div>
            </div>
          </div>

          {/* <div className="container">
            <div className="row">
              <div className="col-12 text-end">
                <button
                  className={`feedback-submit ${
                    chatHistoryId > -1 ? "disable" : ""
                  }`}
                  type="submit"
                  disabled={chatHistoryId > -1}
                  title="Submit Feedback"
                >
                  Submit
                </button>
              </div>
            </div>
          </div> */}
        </form>
      </div>
    );
  };

  const renderMainForm = () => {
    if (chatHistoryId > -1) {
      return renderForm();
    }
    return renderNewForm();
  };

  return renderMainForm();
};

export default Feedback;
